import {get, isEmpty} from "lodash"
import ls from "local-storage"
import React, {useContext, useEffect, useRef, useState} from "react"
import {Div, Icon, Text} from "lib/atomize"
import {useMutation, useLazyQuery, useQuery, useApolloClient} from "@apollo/client"
import {isBefore} from 'date-fns'

import BlueButton from 'components/common/molecules/BlueButton'
//import useScrollPosition from "../../helpers/effects/useScrollPosition"
import {
  ADD_ATTRIBUTES,
  APPLY_DISCOUNT,
  CHECKOUT_BY_ID,
  CHECKOUT_CREATE,
  CHECKOUT_LINE_ITEMS_ADD,
  CART_CREATE,
  CART_LINES_ADD,
  CART_LINES_UPDATE,
  FETCH_CUSTOMER,
  VARIANT_SELLING_PLANS,
  REMOVE_DISCOUNT,
  TOGGLE_CART,
} from "../../graphql/queries"
import {addItemToCheckout, addItemToStorefrontCart, saveCheckoutInLocalStorage,} from "../../services/cartService"
import {trackAddToBag} from '../../helpers/freshpaint';
import {AppContext} from "../../context";
import {useCart} from "../../context/cart";
import { debugCart } from "../../utils/debugCart";
import { matchSellingPlan } from "../../utils/sellingPlanMatcher";
import { debugSubscription } from "../../utils/debugSubscription";
import { shopify } from "../../lib/shopifyClient";
import { STOREFRONT_VARIANT_SELLING_PLANS } from "../../lib/shopifyQueries";
import { formatFrequency, getFrequencyLabel } from "../../utils/frequencyFormatter";

const ProductAddToBag = (
  {
    product,
    count,
    changeCounterValue,
    variant,
    productType,
    frequency,
    ctaText,
    bundles = [],
    toggleStickyCart = false,
    setToggleStickyCart = () => {
    },
  }
) => {

  const addToBagRef = useRef(null);

  //const scrollPosition = useScrollPosition();

  //console.log(scrollPosition);

  const [state, dispatch] = useContext(AppContext);
  const { cart, addLine, status } = useCart();
  const [addAttributes] = useMutation(ADD_ATTRIBUTES)
  const [applyDiscount] = useMutation(APPLY_DISCOUNT, {
    optimisticResponse: response => console.log('optimisticResponse add to bag', response),
    onError: (error => console.error(error))
  })
  const [removeDiscount] = useMutation(REMOVE_DISCOUNT, {
    optimisticResponse: response => console.log(response),
    onError: (error => console.error(error))
  })
  const {tracking, utmParams} = state;
  const [updatingRechargeCheckout, setUpdatingRechargeCheckout] = useState(
    false
  )

  const {data: fetchCustomerData, loading: fetchCustomerLoading} = useQuery(
    FETCH_CUSTOMER,
    {
      skip: !ls("accessToken"),
      variables: {accessToken: ls("accessToken")},
    }
  )

  const [toggleCart] = useMutation(TOGGLE_CART, {
    onCompleted: () => {
      if (window && window.rdt){
        window.rdt('track', 'AddToCart', {
            "currency" : "USD",
            "itemCount": 1,
            "value": 100
        });
      }
    },
  })

  const {data: checkoutData} = useQuery(CHECKOUT_BY_ID, {
    skip: !ls("lastCheckoutID"),
    variables: {id: ls("lastCheckoutID")},
    optimisticResponse: response => console.log('optimisticResponse', response),

  })

  const [checkoutCreate, {loading: creatingCheckout}] = useMutation(
    CHECKOUT_CREATE,
    {
      onError: (error => console.error(error)),
      onCompleted: result => {
        //window.history.pushState("header", "Not Pot", "/#cart")
        toggleCart({variables: {cartDrawerVisible: true}})
        const {checkoutCreate = {}} = result;
        const {checkout = {}} = checkoutCreate;
        if (tracking && !tracking.expired && tracking.expiresAt && isBefore(new Date(), new Date(tracking.expiresAt)) && !tracking.email && tracking.customerId && tracking.referCode && tracking.discountCode) {
          const input = {
            customAttributes: [{key: 'referCode', value: tracking.referCode}, {
              key: 'customerId',
              value: tracking.customerId
            }]
          };
          const checkoutId = checkout.id.toString();
          addAttributes({
            variables: {
              checkoutId,
              input
            }
          }).then(result => {
            const discountCode = tracking.discountCode;
            applyDiscount({
              variables: {
                checkoutId,
                discountCode
              }
            }).then(result => console.info(result))

          }).catch(e => console.error(e))

        } else {
          if (checkout) {
            const checkoutId = checkout.id.toString();
            if (checkoutId) {
              removeDiscount({variables: {checkoutId}});
            }
          }


        }
        saveCheckoutInLocalStorage(result?.checkoutCreate?.checkout)

      },

    }
  )
  const [checkoutLineItemsAdd] = useMutation(CHECKOUT_LINE_ITEMS_ADD)
  const client = useApolloClient()
  const [cartCreate] = useMutation(CART_CREATE)
  const [cartLinesAdd] = useMutation(CART_LINES_ADD)
  const [cartLinesUpdate] = useMutation(CART_LINES_UPDATE)

  const handleCartSuccess = () => {
    toggleCart({ variables: { cartDrawerVisible: true } })
  }

  const customer = get(fetchCustomerData, "customer")

  // subscription selling plans
  const [loadSellingPlans, { data: sellingPlanData }] = useLazyQuery(VARIANT_SELLING_PLANS)

  /**
   * on click on add to cart button
   */

  const onClickAddToCartButton = async () => {
    if (!isEmpty(variant.freebie)) {
      variant.freebie.mode = 'custom'
    }
    trackAddToBag(product, variant, count);
    
    try {
      const variantId = variant._id || variant.id;
      // Extract numeric ID if it's already a gid
      const numericId = variantId.startsWith('gid://') 
        ? variantId.split('/').pop() 
        : variantId;
      const merchandiseId = `gid://shopify/ProductVariant/${numericId}`;
      const encodedVariantId = window.btoa(merchandiseId);
      
      let sellingPlanId = null;
      
      if (productType === "subscribe") {
        // Get selling plan for subscription
        console.log('Loading selling plans for:', encodedVariantId, 'frequency:', frequency);
        
        // Use Storefront API instead of Apollo Client
        const planRes = await shopify.request(STOREFRONT_VARIANT_SELLING_PLANS, { 
          id: encodedVariantId 
        });
        console.log('Selling plan response:', planRes);
        
        const sellingPlanGroups = planRes?.node?.product?.sellingPlanGroups?.edges || [];
        console.log('Selling Plan Groups:', sellingPlanGroups.map(e => ({
          name: e.node.name,
          plans: e.node.sellingPlans?.edges?.map(p => p.node.name)
        })));
        
        const plans = sellingPlanGroups.flatMap(edge => {
          const group = edge.node;
          return (group.sellingPlans?.edges || []).map(planEdge => ({
            ...planEdge.node,
            groupName: group.name
          }));
        });
        
        console.log('Available plans:', plans);
        debugSubscription.logSellingPlanSearch(encodedVariantId, frequency, plans);
        
        if (plans.length) {
          // Use utility function to match selling plan
          sellingPlanId = matchSellingPlan(plans, frequency);
          console.log('Selected selling plan ID:', sellingPlanId, 'for frequency:', frequency);
          
          if (!sellingPlanId) {
            console.error('Failed to match selling plan for frequency:', frequency);
          } else {
            // Verify the selling plan ID format
            console.log('Selling plan ID format check:', {
              id: sellingPlanId,
              isGid: sellingPlanId.startsWith('gid://'),
              fullId: sellingPlanId
            });
          }
        } else {
          console.error('No selling plans found for subscription product');
        }
      }
      
      // Use new cart context
      const attributes = [];
      
      // Add custom variant name if exists
      if (variant.customVariantCartName) {
        attributes.push({ key: '_or', value: variant.customVariantCartName });
      }
      
      // Add subscription frequency for display purposes
      if (productType === "subscribe" && frequency) {
        attributes.push({ key: '_frequency', value: String(frequency) });
        attributes.push({ key: '_delivery_interval', value: getFrequencyLabel(frequency) });
        attributes.push({ key: '_subscription_type', value: 'recurring' });
      }
      
      const cartLine = {
        merchandiseId,
        quantity: count,
        ...(sellingPlanId && { sellingPlanId }),
        ...(attributes.length > 0 && { attributes })
      };
      
      debugCart.logAddToCart(variant, productType, cartLine);
      await addLine(cartLine);
      
      handleCartSuccess();
    } catch (e) {
      console.error('Error adding to cart:', e);
    }
  }

  useEffect(() => {
    const updatePosition = () => {
      if (addToBagRef && addToBagRef.current) {
        if (!toggleStickyCart && document.getElementById('add-to-bag').getBoundingClientRect().top < 0) {
          setToggleStickyCart(true)
        } else if (toggleStickyCart && document.getElementById('add-to-bag').getBoundingClientRect().top > 0) {
          setToggleStickyCart(false)
        }
      }
    };

    window.addEventListener("scroll", updatePosition);

    return () => window.removeEventListener("scroll", updatePosition);

  })

  return (
    <>
      <Div id="add-to-bag" d="flex" justify="space-between" ref={addToBagRef}>
        <Div
          d="flex"
          align="center"
          h="3.125rem"
          minW="4.375rem"
          justify="space-between"
          p="6px 8px 8px"
          bg="white"
          shadow="2"
          rounded="lg"
          m={{r: "10px"}}
          className="addtobag"
        >
          <Div
            d="flex"
            align="center"
            justify="center"
            textWeight="bold"
            onClick={() => changeCounterValue("minus")}
            cursor="pointer"
            p="0 8px"
            h="100%"
            minW="1rem"
          >
            -
          </Div>
          <Text textWeight="bold" m="0 8px">
            {count}
          </Text>
          <Div
            d="flex"
            align="center"
            justify="center"
            textWeight="bold"
            onClick={() => changeCounterValue("plus")}
            cursor="pointer"
            p="0 8px"
            h="100%"
            minW="1rem"
          >
            +
          </Div>
        </Div>
        <BlueButton
          w="100%"
          text={ctaText || 'Add to bag'}
          rounded="lg"
          h="3.125rem"
          onClick={onClickAddToCartButton}
          className="addtobag-btn"
          disabled={status === 'loading'}
          prefix={
            <Icon
              name="Loading"
              pos="absolute"
              top="50%"
              left="8.5%"
              transform="translateY(-50%)"
              size="25px"
              color="white"
              style={{
                zIndex: 1,
                opacity: status === 'loading' ? 1 : 0,
              }}
              m={{r: "0.5rem"}}
            />
          }
        />
      </Div>
    </>
  )
}

export default ProductAddToBag
